'use es6';

import { findWhere } from 'underscore';
import { stringifyIfObject } from './ObjectUtils';
export const getMetaData = (metaData, name) => {
  const metaDataByName = metaData.find(i => i.name === name);
  return metaDataByName ? metaDataByName.value : null;
};
export const removeMetaData = (metaData, name) => metaData.filter(i => i.name !== name);
export const updateMetaData = (metaData, name, value) => [...metaData.filter(i => i.name !== name), ...(value !== null && value !== undefined ? [{
  name,
  value
}] : [])];
export const stringifyMetadataValues = metaData => metaData.map(({
  name,
  value
}) => ({
  name,
  value: stringifyIfObject(value)
}));
export const findMetaDataKey = (metaData, key) => findWhere(metaData, {
  name: key
});